import {
  Board,
  BoardHeader,
  BoardSearchDetail,
  CancelButton,
  ColSpan1,
  ColSpan2,
  ColSpan3,
  ColSpan4,
  ColTitle,
  DownLoadButton,
  Input,
  RelativeDiv,
  RowSpan,
  selectStyle,
  Span4,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import {useAtom} from "jotai";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useLocation, useNavigate} from "react-router-dom";
import {
  accountFileUpload,
  selUserInfo,
  selUserMyPageInfo,
  updateMyPageUser,
  updateUser
} from "../../services/Platform/ManageUserAxios";
import {toast} from "react-toastify";
import Select from "react-select";
import ImageUploading from "react-images-uploading";
import {ModalBody, ModalFooter, ModalHeader} from "../../components/modal/Modal";
import {modalController} from "../../store";
import {
  multiAxiosCall,
  phoneNumFormat,
  phoneNumFormatType2
} from "../../common/StringUtils";
import {hostList} from "../signup/entity/Common";
import {accountInfoAtom} from "./entity/User";
import {adminInfoAtom} from "./entity/Admin";
import {DuplicateButton, InputValidationCon} from "./styles/common";
import {tokenResultAtom} from "../login/entity/Common";
import {IMAGE_SERVER} from "../../constants/GlobalConst";
import {DeleteUser} from "../../components/common/DeleteUser";
import styled from "styled-components";
import PlatformSectionHeader from "./PlatformSectionHeader";

export function PwChange(props) {
  const {onSubmit, modalInfo, onSave, title} = props;
  const [, setModal] = useAtom(modalController)
  const handleModalComponent = () => {
    setModal({
      isShow: true,
      width: 700,
      modalComponent: () => {
        return (
          <PwChangeModal onSave={onSave} modalInfo={modalInfo} onSubmit={onSubmit}/>
        )
      }
    })
  }
  return <DuplicateButton type={'button'} onClick={handleModalComponent}>{title}</DuplicateButton>
}

function PwChangeModal(props) {
  const [showPassword, setShowPassword] = useState(false)
  const [accountInfoState, setAccountInfoState] = useAtom(props.modalInfo === 'USER' ? accountInfoAtom : adminInfoAtom)
  const {register, handleSubmit, watch, formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountInfoState,
  })
  const onError = (error) => console.log(error)
  /**
   * 패스워드 입력
   * @param event
   */
  const handlePassword = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      password: event.target.value
    })
  }
  /**
   * 패스원드 컨펌
   * @param event
   */
  const handleConfirmPassword = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      confirmPassword: event.target.value
    })
  }
  const handleShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleSave = (data) => {
    props.onSave(data)
  }
  return (
    <div>
      <form onSubmit={handleSubmit(handleSave, onError)}>
        <ModalHeader title={'비밀번호 변경'}/>
        <ModalBody>
          <RowSpan>
            <ColSpan4 style={{marginBottom: 10}}>
              <ColTitle><Span4>비밀번호</Span4></ColTitle>
              <RelativeDiv>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={'숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                  maxLength={16}
                  {...register("password", {
                    required: "비밀번호를 입력해주세요",
                    pattern: {
                      value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{8,20}$/,
                      message: "대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)"
                    },
                    onChange: (e)=> handlePassword(e)
                  })}
                  value={accountInfoState.password !== undefined ? accountInfoState.password : ''}
                  //onChange={(e) => handlePassword(e)}
                />
                {errors.password && <ValidationScript>{errors.password?.message}</ValidationScript>}
              </RelativeDiv>
            </ColSpan4>
            <ColSpan1>
              <div onClick={handleShowPassword}>
                <span style={{
                  marginRight: 10,
                  width: 30,
                  height: 30,
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  backgroundImage: `url(/assets/images/common/checkbox_${showPassword ? 'on' : 'off'}_B.png)`
                }}/>
                <span>{showPassword ? '가리기' : '보기'}</span>
              </div>
            </ColSpan1>
          </RowSpan>
          <RowSpan>
            <ColSpan3 style={{width: '80%'}}>
              <ColTitle><Span4>비밀번호 확인</Span4></ColTitle>
              <RelativeDiv>
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder={'대문자, 숫자, 영문, 특수 기호를 포함 (10자 ~ 16자)'}
                  maxLength={16}
                  value={accountInfoState.confirmPassword !== undefined ? accountInfoState.confirmPassword : ''}
                  {...register("confirmPassword", {
                    required: "비밀번호를 입력해주세요",
                    validate: (value) => {
                      if (watch('password') !== value) {
                        return "입력하신 비밀번호를 확인해주세요."
                      }
                    },
                    onChange: (e)=> handleConfirmPassword(e)
                  })}
                  //onChange={(e) => handleConfirmPassword(e)}
                />
                {errors.confirmPassword && <ValidationScript style={{marginBottom: 5, bottom: '-22px'}}>{errors.confirmPassword?.message}</ValidationScript>}
              </RelativeDiv>
            </ColSpan3>
          </RowSpan>
        </ModalBody>
        <ModalFooter>
          <SubmitButton type={"submit"} >변경</SubmitButton>
        </ModalFooter>
      </form>
    </div>
  )
}

function PlatformUserDetail() {
  const [, setModal] = useAtom(modalController)
  const [isDeleteOpen, setIsDeleteOpen] = useState(false)
  const [accountInfoState, setAccountInfoState] = useAtom(accountInfoAtom)
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const {register, handleSubmit, setValue, setError, reset ,formState: {errors}} = useForm({
    mode: "onSubmit",
    defaultValues: accountInfoState
  })
  const onError = (error) => console.log(error)
  const navigate =useNavigate()
  const {state} = useLocation();

  useEffect(() => {
    if(tokenUserInfo.role ==='NORMAL'){
      selUserMyPageInfo(state.id).then(response => {
        if(response) {
          setAccountInfoState(response)
          reset(response)
        }
      })
    }else{
      selUserInfo(state.id).then(response => {
        if(response){
          setAccountInfoState(response)
          reset(response)
        }
      })
    }
    return ()=> {
      setModal({isShow: false})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenUserInfo])


  useEffect(() => {
    if (accountInfoState?.delYn === 'Y') {
      onSubmit();
    }
  }, [accountInfoState?.delYn]);

  /**
   * 광고주명 입력
   * @param event
   */
  const handleAdverName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      adverName: event.target.value
    })
  }
  /**
   * 담당자명 입력
   * @param event
   */
  const handleManagerName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerName: event.target.value
    })
  }
  /**
   * 담당자 연락처 입력
   * @param event
   */
  const handleManagerPhone = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerPhone: event.target.value
    })
  }
  /**
   * 담당자 이메일 입력
   * @param event
   */
  const handleManagerEmail = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      managerEmail: event.target.value
    })
  }

  /**
   * 사업장 업태
   * @param event
   */
  const handleBusiness = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        typeOfBusiness: event.target.value
      }
    })
  }

  /**
   * 사업장 종목
   * @param event
   */
  const handleBusinessType = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        itemsOfBusiness: event.target.value
      }
    })
  }

  /**
   * 사업장 주소
   * @param event
   */
  const handleAddressLocation = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        address: {
          ...accountInfoState.userCompanyProfile.address,
          location: event.target.value
        }
      }
    })
  }

  /**
   * 사업장 주소 상세
   * @param event
   */
  const handleAddressLocationDetail = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        address: {
          ...accountInfoState.userCompanyProfile.address,
          locationDetail: event.target.value
        }
      }
    })
  }
  /**
   * 상호명
   * @param event
   */
  const handleCompanyName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        companyName: event.target.value
      }
    })
  }
  /**
   * 사업자 등록번호
   * @param event
   */
  const handleBusinessNumber = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        businessNumber: event.target.value
      }
    })
  }
  /**
   * 대표명
   * @param event
   */
  const handleCeoName = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        ceoName: event.target.value
      }
    })
  }
  /**
   * 세금 계산서 발행 이메일
   * @param event
   */
  const handleTaxInvoiceEmail = (event) => {
    setAccountInfoState({
      ...accountInfoState,
      userCompanyProfile: {
        ...accountInfoState.userCompanyProfile,
        taxInvoiceEmail: event.target.value
      }
    })
  }


  const imageDownload = (fileUrl) => {
    const url = IMAGE_SERVER + fileUrl;
    let type;
    fetch(url, { method: 'GET' })
    .then((res) => {
      type = res.url.substring(res.url.lastIndexOf('.') + 1)
      return res.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = accountInfoState?.userCompanyProfile.companyName + "_사업자등록증."+type;
      document.body.appendChild(a);
      a.click();
      setTimeout((_) => {
        window.URL.revokeObjectURL(url);
      }, 60000);
      a.remove();
    })
    .catch((err) => {
      console.error('err: ', err);
    });
  };

  const handleBusinessLicense = (pictureFiles) => {
    if(pictureFiles.length !== 0){
      const data = new FormData()
      const imagesLastIndex = pictureFiles.length-1;
      data.append('file', pictureFiles[imagesLastIndex].file, pictureFiles[imagesLastIndex].file.name)
      accountFileUpload( data,'LICENCE').then(response => {
        const { uploadedFile, path } = response;
        if (uploadedFile) {
          toast.success('업로드에 성공 했습니다.')
          setAccountInfoState({
            ...accountInfoState,
            userCompanyProfile: {
              ...accountInfoState.userCompanyProfile,
              businessLicenseWebPath: pictureFiles[imagesLastIndex].file.name
            }
          })
          setValue('businessLicenseWebPath', pictureFiles[imagesLastIndex].file.name)
          setError('businessLicenseWebPath', '')
        } else {
          toast.warning('업로드에 실패 했습니다.')
        }
      })
    }
  }

  /**
   * 사용 여부
   * @param status
   */
  const handleStatus = (status) => {
    setAccountInfoState({
      ...accountInfoState,
      status: status
    })
  }

  /**
   * 사용자 삭제
   * @param delYn
   */
  const handleDelYn = (delYn) => {
    setAccountInfoState({
      ...accountInfoState,
      delYn: delYn
    })
  }
  const handleSelectHosting = (selectHostType) => {
    setAccountInfoState({
      ...accountInfoState,
      hostType: selectHostType.value
    })
  }

  const onSubmit = () => {

    function callbackFunc(response) {
      let id, backLocation;
      if(tokenUserInfo.role==='NORMAL') {
        id = 'updateMyPageUser';
        backLocation = '/board/dashboard';
      } else {
        id = 'updateUser';
        backLocation = '/board/platform';
      }
      if(response){
        toast.success("수정 되었습니다.",{autoClose:100, delay:0, toastId: id})
        toast.onChange(payload => {
          if (payload.status === "removed" && payload.type !== toast.TYPE.ERROR && payload.id === id) {
            navigate(backLocation)
          }
        })
      }else{
        toast.warning("수정이 실패 하였습니다. 관리자한테 문의해주세요")
      }
    }
    function callbackFuncDel(response) {
      if (response[0]) {
        toast.success("삭제 되었습니다.",{onClose: () => tokenUserInfo.role === 'NORMAL' ? navigate('/') : navigate('/board/platform'), autoClose:100, delay:0})
      } else {
        toast.warning("삭제에 실패 하였습니다. 관리자한테 문의하세요")
      }
    }
    multiAxiosCall([tokenUserInfo.role === 'NORMAL' ? updateMyPageUser(accountInfoState) : updateUser(accountInfoState) ], (accountInfoState.delYn === 'Y' ? callbackFuncDel : callbackFunc))

  }
  const handleSavePassword = (data) =>{
    if(tokenUserInfo.role==='NORMAL'){
      updateMyPageUser(data).then(response => {
        if (response) {
          toast.success("비밀번호가 변경되었습니다.",{autoClose:100, delay:0, toastId: 'updateMyPageUser'})
          toast.onChange(payload => {
            if (payload.status === "removed" && payload.type !== toast.TYPE.ERROR && payload.id === 'updateMyPageUser') {
              setModal({
                isShow: false,
                modalComponent: null
              })
            }
          })
        } else {
          toast.warning("수정이 실패 하였습니다. 관리자한테 문의해주세요")
        }
      })
    }else{
      updateUser(data).then(response => {
        if (response) {
          toast.success("비밀번호가 변경되었습니다.",{autoClose:100, delay:0, toastId: 'updateUser'})
          toast.onChange(payload => {
            if (payload.status === "removed" && payload.type !== toast.TYPE.ERROR && payload.id === 'updateUser') {
              setModal({
                isShow: false,
                modalComponent: null
              })
            }
          })
        } else {
          toast.warning("수정이 실패 하였습니다. 관리자한테 문의해주세요")
        }
      })
    }
  }

  const onModalPw = () => {
    setModal({
      isShow: false,
      modalComponent: null
    })
  }
  const onImageError = (errors) => {
    if (errors.maxFileSize) {
      setError('businessLicenseWebPath',{ type: 'maxFileSize', message: '저장 가능한 이미지 사이즈는 5MB 입니다.'})
    } else if (errors.acceptType) {
      setError('businessLicenseWebPath',{ type: 'acceptType', message: '"jpg", "gif", "png"의 형식만 등록 가능합니다.'})
    }
  }
  return (
    <UserDetailPage>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        { accountInfoState !== null &&
          <UserReviewContent>
            <UserReviewHero>
              <UserReviewHeroText>
                <ReviewEyebrow>
                  {tokenUserInfo.role === "NORMAL" ? "MY PAGE" : "USER DETAIL"}
                </ReviewEyebrow>
                <ReviewTitle>
                  {tokenUserInfo.role === "NORMAL"
                      ? "내 계정 정보를 확인하고 관리하세요."
                      : "사용자 정보를 확인하고 수정해 주세요."}
                </ReviewTitle>
                <ReviewDescription>
                  {tokenUserInfo.role === "NORMAL"
                      ? "계정 기본 정보와 사업자 정보를 안전하게 관리할 수 있습니다."
                      : "계정 기본 정보부터 사업자 정보까지 한 화면에서 확인할 수 있습니다."}
                </ReviewDescription>
              </UserReviewHeroText>
              <ReviewMetrics>
                <ReviewMetric>
                  <MetricLabel>계정 상태</MetricLabel>
                  <MetricValue $active={accountInfoState.status === 'NORMAL'}>
                    {accountInfoState.status === 'NORMAL' ? '활성화' : '비활성화'}
                  </MetricValue>
                </ReviewMetric>
                <ReviewMetric>
                  <MetricLabel>계정 구분</MetricLabel>
                  <MetricValue>{accountInfoState.adverType !== 'ADVER' ? '대행사' : '광고주'}</MetricValue>
                </ReviewMetric>
                <ReviewMetric>
                  <MetricLabel>아이디</MetricLabel>
                  <MetricValue title={accountInfoState.username}>{accountInfoState.username || '-'}</MetricValue>
                </ReviewMetric>
                <ReviewMetric>
                  <MetricLabel>광고주명</MetricLabel>
                  <MetricValue title={accountInfoState.adverName}>{accountInfoState.adverName || '-'}</MetricValue>
                </ReviewMetric>
              </ReviewMetrics>
            </UserReviewHero>
            <Board>
              <BoardHeader>
                <DetailSectionTitle>
                  <strong>기본 정보</strong>
                  <span>계정 상태와 광고주 담당자 정보를 확인하고 수정합니다.</span>
                </DetailSectionTitle>
              </BoardHeader>
              <BoardSearchDetail column={true}>
                {tokenUserInfo.role !=='NORMAL' &&
                    <RowSpan>
                      <ColSpan1>
                        <ColTitle><Span4>활성화 여부</Span4></ColTitle>
                        <StatusToggle role="radiogroup" aria-label="활성화 여부">
                          <input type={'radio'}
                                 id={'normal'}
                                 name={'status'}
                                 checked={accountInfoState.status === 'NORMAL'}
                                 onChange={() => handleStatus('NORMAL')}/>
                          <label className="status-normal" htmlFor={'normal'}><StatusToggleDot/>활성화</label>
                          <input type={'radio'}
                                 id={'suspend'}
                                 name={'status'}
                                 checked={accountInfoState.status === 'SUSPEND'}
                                 onChange={() => handleStatus('SUSPEND')}/>
                          <label className="status-suspend" htmlFor={'suspend'}><StatusToggleDot/>비활성화</label>
                        </StatusToggle>
                      </ColSpan1>
                    </RowSpan>
                }
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>광고주 구분</Span4></ColTitle>
                    <div>{(accountInfoState.adverType !=='ADVER') ? '대행사' : '광고주'}</div>
                  </ColSpan2>
                </RowSpan>
                <RowSpan style={{justifyContent: 'flex-start'}}>
                  <ColSpan2>
                    <ColTitle><Span4>아이디</Span4></ColTitle>
                    <RelativeDiv>
                      <Input
                        type={'text'}
                        placeholder={'아이디를 입력해주세요'}
                        value={accountInfoState.username}
                        readOnly={true}
                      />
                    </RelativeDiv>
                  </ColSpan2>
                  <ColSpan1>
                    <PwChange title={'비밀번호 변경'} modalInfo={'USER'} onSave={handleSavePassword} onSubmit={onModalPw}/>
                  </ColSpan1>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>광고주명</Span4></ColTitle>
                    <RelativeDiv>
                      <Input
                        type={'text'}
                        placeholder={'광고주명을 입력해주세요'}
                        value={accountInfoState.adverName}
                        onChange={(e) => handleAdverName(e)}
                      />
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>담당자명</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'담당자 명을 입력해주세요'}
                          {...register("managerName", {
                            required: "담당자 명을 입력해주세요",
                            onChange:(e) => handleManagerName(e)
                          })}
                          value={accountInfoState.managerName}
                        />
                        {errors.managerName && <ValidationScript>{errors.managerName?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>담당자 연락처</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'담당자 연락처를 입력해주세요'}
                          {...register("managerPhone", {
                            required: "담당자 연락처를 입력해주세요.",
                            pattern: {
                              // value: /0([1-9][0-9]?){1,2}?([0-9]{3,4})?([0-9]{4})/g,
                              // value: /0([1-9][0-9]?){1,2}?([0-9]{3,4})?[-]?([0-9]{4})/g,
                              value: /^[0-9-]+$/g,
                              message: "연락처 정보를 확인해주세요"
                            },
                            onChange : (e) => handleManagerPhone(e)
                          })}
                          // value={phoneNumFormatType2(accountInfoState.managerPhone)}
                          value={phoneNumFormatType2(accountInfoState.managerPhone)}
                        />
                        {errors.managerPhone && <ValidationScript>{errors.managerPhone?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>담당자 이메일</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'담당자 이메일을 입력해주세요.'}
                          {...register("managerEmail", {
                            required: "담당자 이메일을 입력해주세요.",
                            pattern: {
                              value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                              message: "이메일 형식을 확인해주세요"
                            },
                            onChange: (e) => handleManagerEmail(e)
                          })}
                          value={accountInfoState.managerEmail}
                        />
                        {errors.managerEmail && <ValidationScript>{errors.managerEmail?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                {/*<RowSpan>*/}
                {/*  <ColSpan2>*/}
                {/*    <ColTitle><Span4>호스팅</Span4></ColTitle>*/}
                {/*    <RelativeDiv>*/}
                {/*      <Select styles={selectStyle}*/}
                {/*              width={200}*/}
                {/*              isSearchable={false}*/}
                {/*              options={hostList}*/}
                {/*              value={accountInfoState.hostType !== '' ? hostList.find(value => value.value === accountInfoState.hostType) : ''}*/}
                {/*              onChange={handleSelectHosting}*/}
                {/*      />*/}
                {/*    </RelativeDiv>*/}
                {/*  </ColSpan2>*/}
                {/*</RowSpan>*/}
              </BoardSearchDetail>
            </Board>
            <Board>
              <BoardHeader>
                <DetailSectionTitle>
                  <strong>사업자 정보</strong>
                  <span>사업자 등록 및 세금계산서 발행에 필요한 정보를 관리합니다.</span>
                </DetailSectionTitle>
              </BoardHeader>
              <BoardSearchDetail column={true}>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>상호명</Span4></ColTitle>
                    <RelativeDiv>
                      <Input
                        type={'text'}
                        placeholder={'상호명'}
                        value={accountInfoState?.userCompanyProfile.companyName}
                        onChange={(e)=>handleCompanyName(e)}
                      />
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan style={{justifyContent: 'flex-start'}}>
                  <ColSpan2>
                    <ColTitle><Span4>사업자 등록 번호</Span4></ColTitle>
                    <RelativeDiv>
                      <Input
                        type={'text'}
                        placeholder={'사업자 등록 번호'}
                        value={accountInfoState?.userCompanyProfile.businessNumber}
                        onChange={(e)=>handleBusinessNumber(e)}
                      />
                      {errors.businessNumber && <ValidationScript>{errors.businessNumber?.message}</ValidationScript>}
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>대표자 성명</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'대표자 성명'}
                          {...register("ceoName", {
                            required: "대표자 성명을 입력해주세요",
                            onChange:(e) => handleCeoName(e)
                          })}
                          value={accountInfoState?.userCompanyProfile.ceoName}
                        />
                        {errors.ceoName && <ValidationScript>{errors.ceoName?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>업태</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'업태'}
                          {...register("typeOfBusiness", {
                            required: "업태를 입력해주세요",
                            onChange:(e) => handleBusiness(e)
                          })}
                          value={accountInfoState?.userCompanyProfile.typeOfBusiness}
                        />
                        {errors.typeOfBusiness && <ValidationScript>{errors.typeOfBusiness?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>종목</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'종목'}
                          {...register("itemsOfBusiness", {
                            required: "종목을 입력해주세요",
                            onChange:(e) => handleBusinessType(e)
                          })}
                          value={accountInfoState?.userCompanyProfile.itemsOfBusiness}
                        />
                        {errors.itemsOfBusiness && <ValidationScript>{errors.itemsOfBusiness?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
                <RowSpan style={{justifyContent: 'flex-start'}}>
                  <ColSpan2>
                    <ColTitle><Span4>사업장 주소</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'사업장 주소'}
                          {...register("location", {
                            required: "주소를 입력해주세요",
                            onChange:(e) => handleAddressLocation(e)
                          })}
                          value={accountInfoState?.userCompanyProfile.address.location}
                        />
                        {errors.location && <ValidationScript>{errors.location?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                  <ColSpan1>
                    <InputValidationCon style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                      <Input
                        type={'text'}
                        placeholder={'상세 주소를 입력해주세요.'}
                        value={accountInfoState?.userCompanyProfile.address.locationDetail}
                        {...register("locationDetail", {
                          onChange:(e) => handleAddressLocationDetail(e)
                        })}
                      />
                    </InputValidationCon>
                  </ColSpan1>
                </RowSpan>
                <RowSpan style={{justifyContent: 'flex-start'}}>
                  <ColSpan2>
                    <ColTitle><Span4>사업자 등록증</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <div style={{width: '100%', display: 'flex', alignItems: 'center'}}>
                          <Input
                            style={{paddingRight: 50}}
                            type={'text'}
                            placeholder={'사업자 등록증'}
                            value={accountInfoState?.userCompanyProfile.businessLicenseWebPath}
                            readOnly={true}
                          />
                          {/*<DownLoadButton type={'button'} onClick={()=> imageDownload(accountInfoState?.userCompanyProfile.businessLicenseWebPath)} />*/}
                        </div>
                        {errors.businessLicenseWebPath && <ValidationScript>{errors.businessLicenseWebPath?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                  <ColSpan1 style={errors.businessLicenseWebPath?.message !== '' ? {paddingBottom: 0} : {paddingBottom: 17}}>
                    <ImageUploading
                      acceptType={["jpg", "gif", "png"]}
                      onChange={handleBusinessLicense}
                      maxFileSize={5242880}
                      onError={(e) => onImageError(e)}
                      maxNumber={1}
                    >
                      {({onImageUpload}) => (
                        <DuplicateButton
                          type={'button'}
                          onClick={onImageUpload}
                        >파일 첨부</DuplicateButton>
                      )}
                    </ImageUploading>
                  </ColSpan1>
                </RowSpan>
                <RowSpan>
                  <ColSpan2>
                    <ColTitle><Span4>세금계산서 발행 이메일</Span4></ColTitle>
                    <RelativeDiv>
                      <InputValidationCon>
                        <Input
                          type={'text'}
                          placeholder={'세금계산서 발행 이메일을 입력해주세요.'}
                          {...register("taxInvoiceEmail", {
                            required: "세금계산서 발행 이메일을 입력해주세요.",
                            pattern: {
                              value: /[a-zA-Z0-9]+[@][a-zA-Z0-9]+[.]+[a-zA-Z]+[.]*[a-zA-Z]*/i,
                              message: "이메일 형식을 확인해주세요"
                            },
                            onChange: (e) => handleTaxInvoiceEmail(e)
                          })}
                          value={accountInfoState?.userCompanyProfile.taxInvoiceEmail}
                        />
                        {errors.taxInvoiceEmail && <ValidationScript>{errors.taxInvoiceEmail?.message}</ValidationScript>}
                      </InputValidationCon>
                    </RelativeDiv>
                  </ColSpan2>
                </RowSpan>
              </BoardSearchDetail>
            </Board>
            { tokenUserInfo.role === 'SUPER_ADMIN' &&
                <DeleteSectionCard>
                  <PlatformSectionHeader
                      title="계정 삭제"
                      description="삭제한 계정은 다시 사용할 수 없으므로 신중하게 진행해 주세요."
                      collapsible
                      open={isDeleteOpen}
                      onToggle={() => setIsDeleteOpen(open => !open)}
                  />
                  {isDeleteOpen && <DeleteSectionBody>
                    <DeleteCard>
                      <DeleteWarningIcon aria-hidden="true">!</DeleteWarningIcon>
                      <DeleteWarningContent>
                        <DeleteWarningHeadline>
                          삭제 후 복구할 수 없습니다
                        </DeleteWarningHeadline>
                        <DeleteWarningText>
                          계정을 삭제하면 개인정보와 서비스 이용 기록이 함께 영구 삭제됩니다. 삭제할 계정을 다시 확인해 주세요.
                        </DeleteWarningText>
                      </DeleteWarningContent>
                      <DeleteActionArea>
                        <DeleteDescription>
                          삭제할 계정과 관련 데이터를 확인한 후 진행해 주세요.
                        </DeleteDescription>
                        <DeleteUser title={"계정 삭제"} buttonText="삭제하기" onSubmit={handleDelYn} btnStyle={'SearchUser'}/>
                      </DeleteActionArea>
                    </DeleteCard>
                  </DeleteSectionBody>}
                </DeleteSectionCard>
            }
          </UserReviewContent>
        }
        <SubmitContainer>
          <DetailActionGuide>
            <DetailActionTitle>사용자 정보 설정</DetailActionTitle>
            <DetailActionDescription>
              변경한 사용자 정보를 확인한 뒤 수정하거나 목록으로 이동할 수 있습니다.
            </DetailActionDescription>
          </DetailActionGuide>
          <DetailActionButtons>
            {tokenUserInfo.role !== 'NORMAL' &&
                <CancelButton type={'button'} onClick={() => navigate(
                    '/board/platform')}>목록</CancelButton>
            }
            <SubmitButton type={"submit"}>수정</SubmitButton>
          </DetailActionButtons>
        </SubmitContainer>
      </form>

    </UserDetailPage>
  )
}

export default PlatformUserDetail

const UserReviewContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  padding: 0;
  background: transparent;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const UserReviewHero = styled.section`
  position: relative;
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: minmax(230px, 0.8fr) minmax(0, 1.6fr);
  gap: 20px;
  align-items: center;
  padding: 19px 20px;
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: linear-gradient(135deg, #fff8f2 0%, #fff 58%);
  box-shadow: 0 5px 16px rgba(31, 41, 55, 0.04);

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 3px;
    background: linear-gradient(90deg, #f5811f, #ffae68);
    content: "";
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

const UserReviewHeroText = styled.div``;
const ReviewEyebrow = styled.div`
  margin-bottom: 7px;
  color: #f5811f;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
`;
const ReviewTitle = styled.h2`
  margin: 0;
  color: #242a31;
  font-size: 20px;
  line-height: 1.35;
  letter-spacing: -0.03em;
`;
const ReviewDescription = styled.p`
  margin: 6px 0 0;
  color: #737c85;
  font-size: 14px;
  line-height: 1.55;
`;
const ReviewMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 9px;

  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;
const ReviewMetric = styled.div`
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid #eceff2;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.88);
`;
const MetricLabel = styled.div`
  margin-bottom: 6px;
  color: #818991;
  font-size: 12px;
`;
const MetricValue = styled.div`
  overflow: hidden;
  color: ${({$active}) => $active ? '#318553' : '#30363d'};
  font-size: 15px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const DeleteSectionCard = styled.section`
  grid-column: 1 / -1;
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const DeleteSectionBody = styled.div`
  padding: 18px 20px 20px;
  background: #fff;
`;

const DeleteCard = styled.div`
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border: 1px solid #efcaca;
  border-radius: 10px;
  background-color: #fff3f3;

  button {
    width: auto;
    min-width: 108px;
    height: 38px;
    padding: 0 16px;
    border: 1px solid #b83f3f;
    border-radius: 7px;
    background: #c94f4f;
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    box-shadow: 0 4px 10px rgba(180, 55, 55, 0.18);
  }

  button:hover:not(:disabled) {
    border-color: #a83232;
    background: #ae3838;
    color: #fff;
  }

  @media (max-width: 760px) {
    grid-template-columns: 42px minmax(0, 1fr);
  }
`;

const DeleteWarningIcon = styled.span`
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #c94f4f;
  color: #fff;
  font-size: 21px;
  font-weight: 900;
`;

const DeleteWarningContent = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 6px;
`;

const DeleteWarningHeadline = styled.div`
  color: #a73d3d;
  font-size: 14px;
  font-weight: 800;
`;

const DeleteWarningText = styled.div`
  color: #7f5c5c;
  font-size: 12px;
  line-height: 1.55;
`;

const DeleteDescription = styled.div`
  color: #9a6a6a;
  font-size: 11px;
  line-height: 1.5;
`;

const DeleteActionArea = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 760px) {
    grid-column: 1 / -1;
    align-items: stretch;

    button {
      width: 100%;
    }
  }
`;

const UserDetailPage = styled.div`
  width: 100%;

  form > div:not(:last-child) {
    margin-bottom: 16px;
  }

  ${Board} {
    min-width: 0;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 1px solid #e4e8ec;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 5px 16px rgba(31, 41, 55, 0.045);
  }

  ${BoardHeader} {
    min-height: 58px;
    padding: 14px 18px;
    border-bottom: 1px solid #eadfd6;
    background: linear-gradient(135deg, #fff8f2 0%, #fff 78%);
  }

  ${BoardSearchDetail} {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    padding: 8px 18px 14px;
    background: #f7f8fa;
  }

  ${RowSpan} {
    min-width: 0;
    min-height: 62px;
    align-items: center;
    gap: 12px;
    margin: 0;
    padding: 10px 12px;
    border-bottom: 1px solid #eceff2;
    background: #fff;

    &:first-child {
      border-radius: 8px 8px 0 0;
    }

    &:last-child {
      border-bottom: 0;
      border-radius: 0 0 8px 8px;
    }

    > div {
      width: 100%;
      padding-left: 0;
    }
  }

  ${ColTitle} {
    width: 112px;
    min-width: 112px;
    color: #555;
    font-size: 13px;
    font-weight: 700;
  }

  ${Span4} {
    width: auto;
  }

  ${RelativeDiv} {
    min-width: 0;
  }

  ${Input} {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    border: 1px solid #dfe3e6;
    border-radius: 8px;
    background: #fff;
    color: #333;
    font-size: 13px;

    &:focus {
      border-color: #f5811f;
      box-shadow: 0 0 0 3px rgba(245, 129, 31, 0.12);
      outline: none;
    }

    &[readonly] {
      border-color: #e6e8ea;
      background: #f6f7f8;
      color: #777;
    }
  }

  ${DuplicateButton} {
    min-width: 92px;
    height: 38px;
    padding: 0 14px;
    border: 1px solid #f1d4c2;
    border-radius: 6px;
    background: #fff8f2;
    color: #d96500;
    font-size: 12px;
    font-weight: 700;
  }

  ${SubmitContainer} {
    position: sticky;
    bottom: 0;
    z-index: 5;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    margin-top: 22px;
    padding: 16px 20px;
    border: 1px solid #ffd7b5;
    border-left: 4px solid #f5811f;
    border-radius: 10px;
    background: linear-gradient(90deg, #fff8f2 0%, rgba(255, 255, 255, 0.98) 48%);
    box-shadow: 0 -4px 20px rgba(245, 129, 31, 0.09);

    button {
      width: auto;
      min-width: 108px;
      height: 40px;
      margin: 0;
      padding: 0 22px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 700;
    }
  }

  @media (max-width: 960px) {
    ${UserReviewContent} {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 640px) {
    ${SubmitContainer} {
      align-items: stretch;
      flex-direction: column;
    }
  }
`;

const DetailSectionTitle = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  strong {
    color: ${({$danger}) => $danger ? '#b84a4a' : '#333'};
    font-size: 15px;
    line-height: 1.2;
  }

  span {
    color: #888;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    text-align: right;
  }
`;

const StatusToggle = styled.div`
  display: inline-flex;
  width: auto !important;
  min-height: 38px;
  align-items: center;
  gap: 6px;
  padding: 4px;
  border: 1px solid #e1e5e8;
  border-radius: 9px;
  background: #f5f6f7;

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
  }

  label {
    display: inline-flex;
    min-width: 86px;
    height: 30px;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 0 12px;
    border: 1px solid transparent;
    border-radius: 6px;
    color: #7b8289;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    transition: 0.15s ease;
  }

  input:focus-visible + label {
    outline: 2px solid rgba(245, 129, 31, 0.3);
    outline-offset: 1px;
  }

  input:checked + label.status-normal {
    border-color: #c8e4d1;
    background: #f1faf4;
    color: #318553;
    box-shadow: 0 2px 6px rgba(49, 133, 83, 0.1);
  }

  input:checked + label.status-suspend {
    border-color: #e5caca;
    background: #fff3f3;
    color: #b84a4a;
    box-shadow: 0 2px 6px rgba(184, 74, 74, 0.1);
  }
`;

const StatusToggleDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
`;

const DetailActionGuide = styled.div`
  min-width: 0;
  text-align: left;
`;

const DetailActionTitle = styled.strong`
  display: block;
  color: #2f3438;
  font-size: 14px;
  font-weight: 800;
`;

const DetailActionDescription = styled.span`
  display: block;
  margin-top: 4px;
  color: #7f878e;
  font-size: 12px;
  line-height: 1.45;
`;

const DetailActionButtons = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 8px;

  @media (max-width: 640px) {
    width: 100%;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;
